import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useWorkspacesLocalStore = create(
  persist(
    (set, get) => ({
      byUser: {},
      listForUser: (userId) => (userId ? get().byUser[userId] ?? [] : []),
      addForUser: (userId, workspace) => {
        if (!userId || !workspace) return
        set((state) => ({
          byUser: {
            ...state.byUser,
            [userId]: [...(state.byUser[userId] ?? []), workspace],
          },
        }))
      },
    }),
    {
      name: 'do-sense-workspaces',
      storage: createJSONStorage(() => localStorage),
      version: 1,
      migrate: (persisted) => persisted ?? { byUser: {} },
      partialize: (state) => ({ byUser: state.byUser }),
    },
  ),
)
